<div ngbDropdown>
    <div class="selenium-resource-collection">
        <span class="label">Collection: </span>
        <app-link
            [ngClass]="{ 'preview-color': isInPreviewMode$ | async }"
            class="primary-collection-link gtm-resource-page-collection selenium-resource-collection-title"
            ngbDropdownAnchor
            appRouterLink="{{ primaryCollection.canonicalUrl }}"
            [attr.data-gtmlabel]="primaryCollection.canonicalUrl"
            >{{ primaryCollection.title }}</app-link
        >
        <button class="panel-trigger" ngbDropdownToggle *ngIf="linksOptions.length">
            <span [ngClass]="isDropdownOpen ? 'arrow-up' : 'arrow-down'"></span>
        </button>
        <span ngbDropdownToggle></span>
    </div>
    <div class="links-panel p-4" ngbDropdownMenu *ngIf="linksOptions.length">
        <app-link
            ngbDropdownItem
            *ngFor="let linkOption of linksOptions"
            class="link-option pb-2 pt-2"
            appRouterLink="{{ linkOption.path }}"
            routerLinkActive="active"
            >{{ linkOption.title }}</app-link
        >
    </div>
</div>
